import { css } from "@emotion/react";

export const pageContainer = css`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const contentArea = css`
  flex: 1;
`;

export const mobileLayout = css`
  padding: 16px;
`;
